<script>
export default {
  model: {
    prop: 'value',
    event: 'onChange'
  },
  props: {
    // form's key value
    formField: {
      type: Array,
      default: () => []
    },
    // form's 校验对象
    formRules: {
      type: Object,
      default: () => { }
    },
    // form's 选择器集合
    formSelectorMap: {
      type: Object,
      default: () => { }
    },
    // form's label width
    labelWidth: {
      type: String,
      default: '400px'
    }
  },
  data () {
    return {
      formModel: {}
    }
  },
  methods: {
    validate () {
      return this.$refs.ruleForm.validate()
    }
  },
  render () {
    const { formRules, formField, formSelectorMap, labelWidth } = this
    const formModel = this.$attrs.value

    return (
      // WTF model 不能直接写在 jsx 上
      <el-form
        rules={formRules}
        ref="ruleForm"
        label-width={labelWidth}
        {...{
          props: { model: formModel }
        }}
      >

        {formField.map(formItem => {
          const {
            label,
            prop,
            isRender = () => true,
            isDisabled = () => false,
            marginBottom,
            component: formComponent,
            componentProps: props
          } = formItem

          if (props && props.selectorListName) {
            props.selectorList = formSelectorMap[props.selectorListName]
          }
          props && (props.disabled = isDisabled(formModel))

          return (isRender(formModel) && (
            <el-form-item
              label={label}
              prop={prop}
              key={formItem.prop}
              style={{ 'margin-bottom': marginBottom || '22px' }}
            >
              <formComponent vModel={formModel[prop]} {...{ props }} />
            </el-form-item>
          ))
        })}

      </el-form >
    )
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  padding-right: 20px;
  color: rgba(51, 51, 51, 1);
  &::after {
    content: "：";
  }
}
</style>
